import DataObject from '../../../common/model/DataObject';

export default class TableauPage extends DataObject {
  getPropertyNames() {
    return [
      'guid',
      'pageTitle',
      'pageIsVisible',
      'pageUrl',
      'displayOrderIndex'
    ];
  }

  getDefaultOverrides() {
    return {
      guid: () => crypto.randomUUID()
    };
  }
}